<template>
  <v-dialog v-model="dShowAlert" persistent max-width="600" hide-overlay>
    <v-card :class="dTypeAlert + 'Alert'">
      <v-card-title class="px-2 py-1">
        <v-btn icon @click="fClose" class="ml-auto">
          <v-icon flat color="datClose">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-4 pt-0">
        <v-row wrap justify="center">
          <v-col v-if="dIconAlert" cols="auto" class="">
            <v-icon large class="icon"> {{ dIconAlert }}
            </v-icon>
          </v-col>
          <v-col cols="12" class="text-center my-3">
            <p class="ffP fs18 fcT2 mb-0">{{dTextAlert}}</p>
            <p class="ffP fs14 fcT240 my-2">{{dTextAlertAux}}</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="dTypeAlert !== 'info'" class="justify-center pb-3">
        <v-btn class="alertBtnText mr-2" depressed @click="fClose">{{dBtnTextCancel}}</v-btn>
        <v-btn class="alertBtn" depressed @click="fAction">{{dBtnText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      dShowAlert: false,
      dTypeAlert: '',
      dTextAlert: '',
      dTextAlertAux: '',
      dIconAlert: '',
      dBtnText: '',
      dBtnTextCancel: ''
    }
  },

  methods: {
    fClose () {
      if (this.fNegAction) {
        this.fNegAction()
      }
      this.dShowAlert = false
    },
    fAction () {
      this.fActionAlert()
      this.dShowAlert = false
    }

  },
  computed: {
  },
  mounted () {
    this.$bus.$on('showAlert', alert => {
      this.dTypeAlert = alert.type ? alert.type : ''
      this.dTextAlert = alert.text ? alert.text : ''
      this.dTextAlertAux = alert.textAux ? alert.textAux : ''
      this.dIconAlert = alert.icon ? alert.icon : ''
      this.dBtnText = alert.btnText ? alert.btnText : this.$t('datAlert.deleteAccept')
      this.dBtnTextCancel = alert.btnTextCancel ? alert.btnTextCancel : this.$t('datAlert.decline')
      this.fActionAlert = alert.action ? alert.action : ''
      this.fNegAction = alert.negAction ? alert.negAction : ''
      this.dShowAlert = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('showAlert')
  }
}
</script>
